<div class="cardContent background">
	<a (click)="openScenarioInformationDialog(station().scenarioId)">
		{{ station().scenarioName }}
	</a>
	<span class="trainingRoom">
		<label class="secondaryLabel"> {{ T.LABEL_ROOM | translate }}: </label>
		<a (click)="openRoomDetailDialog(station().trainingRoomId)">
			@if (station().trainingRoomName) {
				{{ station().trainingRoomName }}
			} @else if (station().trainingRoomId) {
				{{ (station().trainingRoomId | getTrainingRoomById | async)?.name }}
			}
		</a>
	</span>
	<mat-chip-set>
		@defer (when !isLoading()) {
			@for (participant of participants(); track participant.userId) {
				<mat-chip color="accent" (click)="openUserCardDialog(participant.user!)">
					<div class="chipContent">
						@switch (participant.participantType) {
							@case (ParticipantType.Instructor) {
								<mat-icon fontIcon="fa-user-md" fontSet="fas" />
							}
							@case (ParticipantType.StandardizedPatient) {
								<mat-icon fontIcon="fa-user-injured" fontSet="fas" />
							}
							@case (ParticipantType.Learner) {
								<mat-icon fontIcon="fa-user-graduate" fontSet="fas" />
							}
						}
						{{ participant.user?.fullname }}
					</div>
				</mat-chip>
			}
		} @placeholder (minimum 300ms) {
			<mat-spinner diameter="24" />
		}
	</mat-chip-set>
</div>
